import { render } from "./index.vue?vue&type=template&id=50c5fffe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MyAccount/PurchaseHistory/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50c5fffe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50c5fffe', __exports__)) {
    console.log('reload')
    api.reload('50c5fffe', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=50c5fffe", () => {
    console.log('re-render')
    api.rerender('50c5fffe', render)
  })

}


export default __exports__